import { inject, Injectable } from '@angular/core';
import {
  ITrackEventPayload,
  ITrackMetricPayload,
  ITrackRequestPayload,
} from '@epicuro-next/models/platform/monitoring';

import { AbstractAnalyticsService } from '../abstract/abstract-analytics.service';
import { ANALYTICS_TRANSPORT_TOKEN } from '../tokens';

/**
 * Facade service for analytics hadling. Uses Angular dependency injection to get registered analytics services.
 * Services should extend AbstractAnalyticsService and be provided for `ANALYTICS_TRANSPORT_TOKEN` with `multi: true` option
 */
@Injectable()
export class AnalyticsService extends AbstractAnalyticsService {
  private transports = inject<AbstractAnalyticsService[]>(
    ANALYTICS_TRANSPORT_TOKEN,
    { optional: true },
  );

  /**
   * Constructor
   * @param transports
   */
  constructor() {
    super();
    const transports = this.transports;

    if (!transports) {
      this.transports = [];
    }
  }

  /**
   * Tracks a specific event.
   * @param trackEventPayload
   */
  public trackEvent(trackEventPayload: ITrackEventPayload): void {
    this.transports?.forEach((transport) => {
      try {
        transport.trackEvent(trackEventPayload);
      } catch (e) {}
    });
  }

  /**
   * Tracks the payload of a request
   * @param trackRequestPayload
   */
  public trackRequestMetrics(trackRequestPayload: ITrackRequestPayload): void {
    this.transports?.forEach((transport) => {
      try {
        transport.trackRequestMetrics(trackRequestPayload);
      } catch (e) {}
    });
  }

  /**
   * Tracks a numeric metric
   * @param trackMetricPayload
   */
  public trackMetric(trackMetricPayload: ITrackMetricPayload): void {
    this.transports?.forEach((transport) => {
      try {
        transport.trackMetric(trackMetricPayload);
      } catch (e) {}
    });
  }
}
